import {
    createContext
} from "react";

export const BadgeIndicatorAnchorContext = createContext<((inset: number | null) => void) | null>(null);
